var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C5F66",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.969 4.673a1.093 1.093 0 1 1-2.187 0 1.093 1.093 0 0 1 2.187 0M8.785 7.669v3.605a.91.91 0 1 1-1.82 0V7.67a.91.91 0 0 1 1.82 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0a7.875 7.875 0 1 0 0 15.75 7.875 7.875 0 0 0 0-15.75zm4.579 12.454a6.478 6.478 0 0 1-9.196.038 6.474 6.474 0 0 1 .038-9.196 6.478 6.478 0 0 1 9.196-.038 6.474 6.474 0 0 1-.038 9.196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0a7.875 7.875 0 1 0 0 15.75 7.875 7.875 0 0 0 0-15.75zm4.579 12.454a6.478 6.478 0 0 1-9.196.038 6.474 6.474 0 0 1 .038-9.196 6.478 6.478 0 0 1 9.196-.038 6.474 6.474 0 0 1-.038 9.196z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.30a7af0b33d37b1391c00e16361143de.svg";
export { ForwardRef as ReactComponent };